var map = {
	"./banner/ru-KZ.json": [
		1420,
		160
	],
	"./banner/ru-RU.json": [
		1421,
		161
	],
	"./calculator/en-RU.json": [
		1422,
		162
	],
	"./calculator/en.json": [
		1423,
		163
	],
	"./calculator/ru-KZ.json": [
		1424,
		164
	],
	"./calculator/ru-RU.json": [
		1425,
		165
	],
	"./sharing/en-RU.json": [
		1426,
		166
	],
	"./sharing/en.json": [
		1427,
		167
	],
	"./sharing/ru-KZ.json": [
		1428,
		168
	],
	"./sharing/ru-RU.json": [
		1429,
		169
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 907;
module.exports = webpackAsyncContext;